import {CountUp} from "countup.js"

const numbers = document.querySelectorAll<HTMLElement>(".i-counter-number__value")

numbers.forEach((numberEl) => {
  if (numberEl.dataset.value) {
    const endValue = Number(numberEl.dataset.value)
    const decimalPlaces = numberEl.dataset.value.includes(".") ? 1 : 0

    new CountUp(numberEl, endValue, {
      enableScrollSpy: true,
      scrollSpyOnce: true,
      separator: " ",
      decimal: ",",
      decimalPlaces: decimalPlaces,
    })
  }
})
